import { render, staticRenderFns } from "./SummoningOrderItem.vue?vue&type=template&id=108be7f0&scoped=true"
import script from "./SummoningOrderItem.vue?vue&type=script&lang=js"
export * from "./SummoningOrderItem.vue?vue&type=script&lang=js"
import style0 from "./SummoningOrderItem.vue?vue&type=style&index=0&id=108be7f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108be7f0",
  null
  
)

export default component.exports